import TranscriptSettings from './TranscriptSettings';

export default TranscriptSettings;
